import { AxiosResponse } from 'axios';
import {
  UseMutateFunction,
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { useSnackbar } from '@commons/snackbar';

export type useCustomMutationProps<T> = UseMutateFunction<
  AxiosResponse<any, any>,
  unknown,
  T,
  unknown
>;
export type useCustomAsyncMutationProps<T> = UseMutateAsyncFunction<
  AxiosResponse<any, any>,
  unknown,
  T,
  unknown
>;

type Props = {
  deleteAll?: boolean;
  message?: string;
  callbackSuccess?: any;
  callbackError?: any;
};
export const useCustomMutation = <T>(
  key: string[],
  service: any,
  { deleteAll, message, callbackSuccess, callbackError }: Props
) => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse<any, any>, unknown, T, unknown>({
    mutationKey: key,
    mutationFn: service,
    onMutate: async (newData) => {
      await queryClient.cancelQueries({ queryKey: key });
      const previousValue = queryClient.getQueryData(key);
      // queryClient.setQueryData(key, newData);
      return { previousValue };
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({ queryKey: [key[0]] });
      if (deleteAll) await queryClient.invalidateQueries();
      if (message) enqueueSnackbar(message, { variant: 'success' });
      await callbackSuccess?.(data);
    },
    onError: (error: any, newData, context: any) => {
      queryClient.setQueryData(key, context?.previousValue);
      if (callbackError) {
        callbackError();
      } else {
        enqueueSnackbar('Ups! Ha occurido un error!, intentalo nuevamente', { variant: 'error' });
      }
    },
  });
};
